import { render, staticRenderFns } from "./PayslipStatusChip.vue?vue&type=template&id=755dede2"
import script from "./PayslipStatusChip.vue?vue&type=script&lang=js"
export * from "./PayslipStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports